import React from 'react';
import { Paper, Grow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	warning: {
		background: theme.palette.warning.main,
		color: 'black',
		padding: '1rem',
		margin: '1rem',
		fontWeight: 'bold',
	},
	error: {
		background: theme.palette.error.main,
		color: 'white',
		padding: '1rem',
		margin: '1rem',
		fontWeight: 'bold',
	},
	success: {
		background: theme.palette.success.main,
		color: 'white',
		padding: '1rem',
		margin: '1rem',
		fontWeight: 'bold',
	},
}));

export const ErrorAlert = (props) => {
	const classes = useStyles();
	return (
		<Grow in={true}>
			<Paper className={classes.error} {...props} />
		</Grow>
	);
};

export const WarningAlert = (props) => {
	const classes = useStyles();
	return (
		<Grow in={true}>
			<Paper className={classes.warning} {...props} />
		</Grow>
	);
};

export const SuccessAlert = (props) => {
	const classes = useStyles();
	return (
		<Grow in={true}>
			<Paper className={classes.success} {...props} />
		</Grow>
	);
};
